import type { EntityConfig } from '../types'

export const disputeRailEntity: EntityConfig = {
  name: 'dispute-rail',
  displayName: 'Chargeback',
  pluralName: 'Chargebacks',
  status: {
    field: 'status',
    options: [
      { value: 'received', label: 'Received', color: 'warning' },
      { value: 'under_review', label: 'Under Review', color: 'info' },
      { value: 'rebutted', label: 'Rebutted', color: 'info' },
      { value: 'won', label: 'Won', color: 'success' },
      { value: 'lost', label: 'Lost', color: 'error' },
      { value: 'pre_arbitration', label: 'Pre-Arbitration', color: 'warning' },
      { value: 'arbitration', label: 'Arbitration', color: 'error' },
      { value: 'expired', label: 'Expired', color: 'neutral' },
    ],
    filters: [
      { label: 'All', value: 'all' },
      { label: 'Received', value: 'received' },
      { label: 'Under Review', value: 'under_review' },
      { label: 'Rebutted', value: 'rebutted' },
      { label: 'Won', value: 'won' },
      { label: 'Lost', value: 'lost' },
      { label: 'Pre-Arbitration', value: 'pre_arbitration' },
      { label: 'Arbitration', value: 'arbitration' },
      { label: 'Expired', value: 'expired' },
    ],
    mappings: {
      all: ['received', 'under_review', 'rebutted', 'won', 'lost', 'pre_arbitration', 'arbitration', 'expired'],
      received: ['received'],
      under_review: ['under_review'],
      rebutted: ['rebutted'],
      won: ['won'],
      lost: ['lost'],
      pre_arbitration: ['pre_arbitration'],
      arbitration: ['arbitration'],
      expired: ['expired'],
    },
  },
  queryFields: {
    status: { field: 'status', type: 'select', label: 'Status' },
    network: { field: 'network', type: 'select', label: 'Network' },
    reason: { field: 'reason', type: 'select', label: 'Reason' },
  },
  uiFilterFields: ['status', 'network', 'reason'],
}
